angular.module("AccountingBoxApp").config(function($stateProvider) {
  $stateProvider
    .state("app.company.journalEntries", {
      abstract: true,
      template: "<ui-view/>",
      url: "/memoriaal"
    })
    .state("app.company.edit.journalEntries", {
      url: "/memoriaal/:id/bewerk",
      templateUrl: "app/journalEntries/edit/edit.html",
      controller: "JournalEntriesEditCtrl",
      controllerAs: "jee"
    })
    .state("app.company.new.journalEntries", {
      url: "/memoriaal/nieuw/:id",
      templateUrl: "app/journalEntries/edit/edit.html",
      controller: "JournalEntriesEditCtrl",
      controllerAs: "jee",
      params: {
        attachment: null,
        id: {
          value: null,
          squash: true
        }
      }
    })
    .state("app.company.journalEntries.list", {
      url: "",
      templateUrl: "app/journalEntries/list/list.html",
      controller: "JournalEntriesListCtrl",
      controllerAs: "jel"
    });
});
